import React, { useEffect, useRef, useState } from 'react'
import { CircularProgress, Modal, Typography } from '@mui/material';

type LoadingIndiactorModalProps = {
    text: string,
}

const LoadingIndiactorModal = ({ text }: LoadingIndiactorModalProps) => {
    return (
        <Modal disableAutoFocus={true} open={true} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
            <div style={{ width: "200px", display: "flex", justifyContent: "space-evenly", flexDirection: "column" }}>
                <CircularProgress style={{ alignSelf: "center", marginBottom: "10px", }} size="4rem" color="warning" />
                <Typography align='center' fontSize={"1.3rem"} color={"white"}>{text}</Typography >
            </div>
        </Modal>
    )
}

export default LoadingIndiactorModal;